import authorizationCache from 'services/config/authorizationCache';
import { record, LogoutType } from './nimKick';
import chatttSDK from '../services/chattt';
import nimInst from 'services/nim';
import report from './deviceIdTracker';

async function logout(logoutType?: LogoutType) {
  const { storage = sessionStorage, cacheKey = `@${import.meta.env.VITE_NAME}-token` } =
    authorizationCache;

  const token = storage.getItem(cacheKey);
  if (token) {
    report('$deviceLogout', token, { logoutType: logoutType || 'userLogout' });

    if (chatttSDK?.account?.logoutUser) {
      chatttSDK.account.logoutUser(token);
    }
  }
  await nimInst.logout();
  await chatttSDK?.tokoBridge?.closeAllViews();

  storage.removeItem(cacheKey);
  localStorage.removeItem('token');
  localStorage.removeItem('orgId');

  const {
    location: { origin, search, pathname },
  } = window;

  let query = '';
  if (logoutType) {
    query = `?logoutType=${logoutType}`;
    record(logoutType);
  }

  if (origin.startsWith('file:')) {
    window.location.replace(`${origin}${pathname}${query}`);
  } else {
    window.location.replace(`${origin}${search ? '/' : '/?chat=++'}#/login${query}`);
  }
}

export default logout;
